import type { WorkspaceDTO } from '../interfaces/workspace.interface';

/** Name order that tolerates workspaces without a name. */
export const sortWorkspacesByName = (workspaces: WorkspaceDTO[] | null | undefined): WorkspaceDTO[] =>
  [...(workspaces ?? [])].sort((a, b) => (a.name ?? '').localeCompare(b.name ?? ''));
